import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Avatar, Box, CardHeader, CardMedia, Fab, Fade, Grid, IconButton, Skeleton, Typography, useScrollTrigger } from '@mui/material';
import { useFetchMaterial } from '../../hooks/fetchs-material';
import { useAuth } from '../../hooks/useAuth';
// import Mata_Tags from '../layout/meta-tags';
import CommentMats from '../comments/comment-mats';
import PropTypes from 'prop-types';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HomeIcon from '@mui/icons-material/Home';

import config from '../../config-site'


const address_api = config[0].address;

// export default useDeviceSize ;
function ScrollTop({ children }) {
    const trigger = useScrollTrigger({
        target: window ,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
    
        const anchor = (event.target.ownerDocument || document).querySelector(
        '#back-to-top-detail',
        );

        if (anchor) {
            anchor.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
                top: 0, left: 0
            });
        }
    };

    return (
    <Fade in={trigger} >
        <Box
        onClick={(e) => handleClick(e)}
        role="presentation"
        sx={{ position: 'fixed', bottom: 160, left: 16 }}
        >
        {children}
        </Box>
    </Fade>
    );
}

ScrollTop.propTypes = {
children: PropTypes.element.isRequired,
// window: PropTypes.func,
};


function MaterialDetails() {
    const { authData, authDataLang } = useAuth();
    const { main, type, id } = useParams();
    const [ data, loading, error ] = useFetchMaterial(type, id, authDataLang?.id);
    const [isAdmin, setIsAdmin] = useState(false);
    const [matHashTag, setMatHashTag ] = useState(null);
    const didSetMeta = useRef(false);
    const [materials, setMaterials] = useState(null);
    const navigate = useNavigate();
    
    // const [imageLoading, setimageLoading] = useState(true);
    // const counter = useRef(0);
    // const imageLoaded = () => {
    //     counter.current += 1;
    //     if (counter.current >= materials?.material?.image_lists.length) {
    //         setimageLoading(false);
    //     }
    // }
    // const scroll = () => {
    //     const section = document.querySelector( '#contact-us' );
    //     section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
    // };
    // var foundHash;
    useEffect(()=>{
        // window.scrollTo(0, 0);
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium);
        }

        setMaterials(data);
        setMatHashTag(data?.material?.hash_tag);
        
    }, [data, authData])

    

    const editMaterial = (id) => {
        let obj = [];
        if(id){
            obj = Object.assign(id, {'matbuy_id': materials.id}, {'group': materials?.material?.group});
        }else{
            obj = Object.assign({'material' : materials?.material?.id}, {'matbuy_id': materials.id}, {'group': materials?.material?.group});
        }
        // myItems.push(id);
        // myItems.extend({'matbuy_id': materials.id});
        navigate('/mat-new', {state : obj});
    }
    
    const editLinks = (id) => {
        let obj = Object.assign(id, {'matbuy_id': materials.id});
        navigate('/mat-link', {state : obj});
    }
    
    // const usePageMeta = (title, description) =>{
    //     const defaultTitle = "app-name";
    //     const defaultDesc = "meta description";
    
    //     useEffect(() => {
    //         document.title = title || defaultTitle;
    //         document.querySelector("meta[name='description']").setAttribute("content", description || defaultDesc);
    //     }, [defaultTitle, title, defaultDesc, description]);
    // }
    // usePageMeta("Demo Page Title", "Demo meta description");
    setTimeout(function(){ 
        var hash_tag = window.location.hash;
        let flagAction = 0;
        
        if(hash_tag){
            if(hash_tag.length > 5)
            {
                const anchor = document.querySelector(
                    hash_tag,
                    );
                    // const anchor = document.getElementById(hash_tag.substring(1));
                    if (anchor) {
                        flagAction = 1;
                        anchor.scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                            top: 0, left: 0
                        });
                    }
            }
        }
        if(flagAction === 0){
            window.scrollTo(0, 0);
        }
    }, 500);
    

    useEffect(() => {
      if (!materials?.material || didSetMeta.current) return;
    
      const m = materials.material;
    
      if (m.name) document.title = m.name;
    
      if (m.meta_description) {
        const desc = document.querySelector("meta[name='description']");
        desc?.setAttribute('content', m.meta_description);
      }
    
      if (m.keywords) {
        const keywords = document.querySelector("meta[name='keywords']");
        keywords?.setAttribute('content', m.keywords);
      }
    
      if (m.author) {
        const author = document.querySelector("meta[name='author']");
        author?.setAttribute('content', m.author);
      }
    
      if (m.meta_og_title) {
        const ogTitle = document.querySelector("meta[property='og:title']");
        ogTitle?.setAttribute('content', m.meta_og_title);
      }
    
      if (m.image) {
        const ogImage = document.querySelector("meta[property='og:image']");
        ogImage?.setAttribute('content', m.image);
      }
    
      if (m.alt_image) {
        const ogImageAlt = document.querySelector("meta[property='og:image:alt']");
        ogImageAlt?.setAttribute('content', m.alt_image);
      }
    
      if (m.meta_description) {
        const ogDesc = document.querySelector("meta[property='og:description']");
        ogDesc?.setAttribute('content', m.meta_description);
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      ogUrl?.setAttribute('content', document.location.href);
    
      // فقط یک‌بار اجرا شود
      didSetMeta.current = true;
    
    }, [materials?.material]);

    return (
        <React.Fragment>
            {/* <Helmet>
                <title>{materials?.material?.name ? materials?.material?.name : "صفحه اصلی | اِتک (ETEC)"}</title>
                <meta name="description" content={materials?.material?.meta_description ? materials?.material?.meta_description : "ETEC.IR بستری نوین برای آموزش، فناوری و توسعه مهارت‌های دیجیتال در ایران."} />
                <meta name="keywords" content={materials?.material?.keywords ? materials?.material?.keywords : "ETEC, آموزش, فناوری, مهارت‌های دیجیتال, ایران, آموزش آنلاین"} />
                <meta name="robots" content="index, follow" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta http-equiv="Content-Language" content="fa" />
                <meta name="author" content={materials?.material?.author ? materials?.material?.author : "ETEC.IR"} />

                <meta property="og:title" content={materials?.material?.meta_og_title ? materials?.material?.meta_og_title : "ETEC.IR | سامانه آموزش و فناوری"} />
                <meta property="og:description" content={materials?.material?.meta_description ? materials?.material?.meta_description : "ETEC.IR بستری نوین برای آموزش، فناوری و توسعه مهارت‌های دیجیتال در ایران."} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://etec.ir" />
                <meta property="og:image" content={materials?.material?.image ? materials?.material?.image : "https://etec.ir/static/images/og-image.jpg"} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={materials?.material?.meta_og_title ? materials?.material?.meta_og_title : "ETEC.IR | سامانه آموزش و فناوری"} />
                <meta name="twitter:description" content={materials?.material?.meta_description ? materials?.material?.meta_description : "ETEC.IR بستری نوین برای آموزش، فناوری و توسعه مهارت‌های دیجیتال در ایران."} />
                <meta name="twitter:image" content={materials?.material?.image ? materials?.material?.image : "https://etec.ir/static/images/twitter-card.jpg"} />
            </Helmet> */}
            <div style={{minHeight: 1000}} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
                <Link to={`/${type}/#${matHashTag}`}>
                    <Avatar >
                        <HomeIcon color='primary' sx={{ fontSize: 40}}/>
                    </Avatar>    
                </Link>
                {/* <div >
                    <Mata_Tags tags={materials?.material}/>
                </div> */}
                {loading ?
                <Box sx={{ width: '100%' }}>
                    <Skeleton />
                    <Skeleton variant="rectangular" width='100%' height={300} />
                    <Skeleton animation="wave" />
                    <Skeleton animation={false} />
                    <Skeleton variant="circular" width={40} height={40} />
                    <Skeleton variant="rounded" width='100%' height={150} />
                </Box>
                :
                <div>
                    <Link id='back-to-top-detail' />
                    {isAdmin &&
                        <Grid container >
                            <CardHeader
                                action={
                                <IconButton aria-label="settings" 
                                    color='secondary'
                                    onClick={() => {
                                        editMaterial()
                                    }}
                                >
                                    <AddCircleIcon />
                                </IconButton>
                                }
                                />
                        </Grid>
                    }
                    { materials && 
                        <div >
                            <Grid container spacing={2}>
                                <Box
                                    
                                    sx={{
                                        p: 2,
                                        display: 'block',
                                        gap: 2,
                                        width: '100%'
                                    }}
                                    >
                                    <div > 
                                        {/* <Paper elevation={1} sx={{
                                                    marginBottom: '1rem',
                                                    marginTop: '1rem',
                                                    paddingTop: '1rem',
                                                }} > */}
                                            <Box sx={{
                                                    marginLeft: '1rem',
                                                    marginRight: '1rem',
                                                    paddingBottom: '2rem',
                                                }}
                                                
                                                >
                                                {/* <div style={{visibility: imageLoading ? "hidden" : "visible"}}> */}
                                                    <CardMedia
                                                        // placeholder={(<Skeleton variant="rectangular" width='100%'  />)}
                                                        component="img"
                                                        sx={{maxHeight: 380}}
                                                        alt={materials.material.alt_image}
                                                        image={String(materials?.material?.image).startsWith(address_api) ? materials.material.image : `${address_api}${materials.material.image}`}
                                                        loading='lazy'
                                                    />
                                                    
                                                <br/>

                                                <Typography 
                                                    sx={{ 
                                                        fontFamily:'Segoe UI', 
                                                        
                                                        }} 
                                                    gutterBottom 
                                                    variant="h4" 
                                                    component="div" 
                                                    >
                                                    <b>{materials.material.name}</b>
                                                </Typography>

                                                <Typography 
                                                    sx={{ 
                                                        fontFamily:'Segoe UI', 
                                                        textAlign: 'justify' 
                                                        }} 
                                                    variant="h6" 
                                                    component="div"
                                                    color="text.secondary">
                                                    {/* {materials.material.description} */}
                                                    <div dangerouslySetInnerHTML={{ __html: materials.material.description }} />
                                                </Typography>
                                            </Box>
                                        {/* </Paper> */}
                                    </div>                            
                                    {materials?.material?.image_lists?.map( mat => {
                                        return <div key={mat.id} id={mat?.hash_tag} > 
                                            {isAdmin &&
                                                    <Grid container spacing={1} alignItems='flex-end'>
                                                        <Grid item >
                                                            <IconButton aria-label="settings" 
                                                                color='secondary'
                                                                onClick={() => {
                                                                    editMaterial(mat)
                                                                }}
                                                                >
                                                                <AutoStoriesIcon />
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid item >
                                                            <IconButton aria-label="settings" 
                                                                color='secondary'
                                                                onClick={() => {
                                                                    editLinks(mat)
                                                                }}
                                                                >
                                                                <AdsClickIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                            }
                                            <Box 
                                                sx={{
                                                    marginLeft: '1rem',
                                                    marginRight: '1rem',
                                                    paddingBottom: '2rem',
                                                    
                                                }}
                                                >
                                                {mat.description_end &&
                                                    <div>
                                                        <Typography 
                                                            sx={{ 
                                                                fontFamily:'Segoe UI', 
                                                                textAlign: 'justify'
                                                            }} 
                                                            gutterBottom 
                                                            variant="h4" 
                                                            component="div" >
                                                            {mat.name}
                                                        </Typography>
                                                        <Typography 
                                                            sx={{ fontFamily:'Segoe UI', textAlign: 'justify' }} 
                                                            variant="h6" 
                                                            component="div"
                                                            color="text.secondary"
                                                            dir={authDataLang?.view_sts ? "rtl" : "ltr"}
                                                            >
                                                            <div dangerouslySetInnerHTML={{ __html: mat.comments }} />
                                                        </Typography>
                                                    </div>
                                                }
                                                
                                                <CardMedia
                                                    // placeholder={(<Skeleton variant="rectangular" width='100%'  />)}
                                                    sx={{
                                                        maxHeight: 380
                                                    }}
                                                    component="img"
                                                    alt={mat.alt_image}
                                                    image={String(mat.image).startsWith(address_api) ? mat.image : `${address_api}${mat.image}`}
                                                    loading='lazy'

                                                    // onLoad={imageLoaded}
                                                />
                                                <br/>
                                                {!mat.description_end &&
                                                    <Typography 
                                                        sx={{ 
                                                            fontFamily:'Segoe UI', 
                                                            textAlign: 'justify'
                                                        }} 
                                                        gutterBottom 
                                                        variant="h4" 
                                                        component="div" >
                                                        {mat.name}
                                                    </Typography>
                                                }
                                                <Typography 
                                                    sx={{ fontFamily:'Segoe UI', textAlign: 'justify' }} 
                                                    variant="h6" 
                                                    component="div"
                                                    color="text.secondary"
                                                    dir={authDataLang?.view_sts ? "rtl" : "ltr"}
                                                    >
                                                    {mat.description_end ?
                                                        <div dangerouslySetInnerHTML={{ __html: mat.comments_end }} />
                                                    :
                                                        <div dangerouslySetInnerHTML={{ __html: mat.comments }} />
                                                    }
                                                </Typography>
                                            </Box>
                                        </div>
                                    })}
                                </Box>
                            </Grid>
                        </div>
                    }
                    <Typography 
                        sx={{ 
                            fontFamily:'Segoe UI', 
                            textAlign: 'justify'
                        }} 
                        gutterBottom 
                        variant="h5" 
                        component="div" >
                        {/* <b>لطفا امتیاز و پیشنهاد خود را برای ما ارسال کنید</b> */}
                        <b>{authDataLang?.site_langs?.desc_comments}</b>
                    </Typography>
                    { materials && 
                        <div>
                            <CommentMats materials={materials}/>
                        </div>
                    }
                    <ScrollTop >
                        <Fab size="small" aria-label="scroll back to top" color="secondary">
                            <KeyboardArrowUpIcon />
                        </Fab>
                    </ScrollTop>
                </div>
                }
            </div>
        </React.Fragment>
    );
}

export default MaterialDetails;
